<nav class="sticky z-[999] top-0 px-6 border-b transition-all duration-300 h-16 flex items-center 
         bg-white/80 border-[#EAEAEA] backdrop-blur-xl 
         dark:bg-surface-1/90 dark:border-line">
    <div class="flex items-center justify-between w-full h-full">
        <!-- Breadcrumbs and Date -->
        <div class="flex flex-col">
            <div class="text-[#141437] dark:text-white font-medium text-lg leading-tight">
                {{ breadcrumbs() }}
            </div>
            <div class="text-xs text-slate-600 dark:text-slate-400 mt-0.5">
                {{ currentDateTime() }}
            </div>
        </div>

        <!-- Actions -->
        <div class="flex items-center gap-4">
            <!-- Theme Toggle Button -->
            <app-theme-toggle variant="toggle"
                [buttonClass]="'border border-gray-200 dark:border-indigo-900'"></app-theme-toggle>

            <!-- Separator -->
            <div class="h-8 w-px bg-gray-300 dark:bg-gray-500/50"></div>

            <!-- User Menu -->
            <div class="relative">
                <button (click)="toggleUserMenu()" aria-label="Open user menu" class="rounded-full transition-all duration-300 
                 bg-gradient-to-br from-purple-600 to-indigo-600 text-white 
                 hover:from-purple-500 hover:to-indigo-500 
                 dark:from-purple-500 dark:to-indigo-500 
                 dark:hover:from-purple-600 dark:hover:to-indigo-600"
                    [class]="photoUrl() ? 'p-0.5' : 'p-2'">
                    @if (photoUrl(); as photo) {
                    <!-- no-referrer: Google's photo host can refuse requests that carry one -->
                    <img [src]="photo" alt="" referrerpolicy="no-referrer"
                        class="block w-8 h-8 rounded-full object-cover bg-white dark:bg-slate-800"
                        (error)="photoFailed.set(true)" />
                    } @else {
                    <span class="flex w-5 h-5 items-center justify-center text-xs font-semibold leading-none">
                        {{ initials() }}
                    </span>
                    }
                </button>

                <!-- Dropdown Menu -->
                @if (showUserMenu()) {
                <div #profileRef class="absolute right-0 mt-2 w-72 rounded-lg shadow-xl overflow-hidden z-50
                   transition-all duration-300 
                   bg-white/95 border border-purple-200 
                   backdrop-blur-xl 
                   dark:bg-slate-800/95 dark:border-purple-500/20">
                    <!-- The one place the signed-in user's profile is shown -->
                    <div class="flex items-center gap-3 px-4 py-4 border-b border-purple-200 dark:border-purple-500/20">
                        @if (photoUrl(); as photo) {
                        <img [src]="photo" alt="" referrerpolicy="no-referrer"
                            class="w-11 h-11 shrink-0 rounded-full object-cover bg-white dark:bg-slate-800"
                            (error)="photoFailed.set(true)" />
                        } @else {
                        <div class="w-11 h-11 shrink-0 rounded-full flex items-center justify-center text-white font-semibold text-sm
                            bg-gradient-to-br from-purple-500 to-indigo-500 dark:from-purple-600 dark:to-indigo-600">
                            {{ initials() }}
                        </div>
                        }
                        <div class="min-w-0 flex-1">
                            <p class="truncate text-sm font-medium text-slate-900 dark:text-white" [title]="displayName()">
                                {{ displayName() }}
                            </p>
                            @if (user()?.email; as email) {
                            <p class="truncate text-xs text-slate-600 dark:text-slate-400" [title]="email">
                                {{ email }}
                            </p>
                            }
                        </div>
                    </div>
                    <button (click)="handleProfile()" class="w-full flex items-center gap-3 px-4 py-3 transition-colors 
                     text-slate-700 hover:bg-slate-50 
                     dark:text-slate-300 dark:hover:bg-slate-700/50">
                        <app-icon name="user" [size]="16" />
                        Profile
                    </button>
                    <button (click)="handleLogout()" class="w-full flex items-center gap-3 px-4 py-3 transition-colors 
                     text-red-600 hover:bg-red-50 
                     dark:text-red-300 dark:hover:bg-red-500/10">
                        <app-icon name="logOut" [size]="16" />
                        Logout
                    </button>
                </div>
                }
            </div>
        </div>
    </div>
</nav>